import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const PICKER_LOW = 'low';
const PICKER_HI = 'hi';

export class RangePicker extends Component {
  state = {
    lastUsed: PICKER_LOW,
  };

  componentDidMount() {
    this.positionRangeMarker();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value.join(',') !== prevProps.value.join(',')) {
      this.positionRangeMarker();
    }
  }

  handleInput = event => {
    if (parseInt(this.lowEl.value, 10) > parseInt(this.hiEl.value, 10)) {
      event.preventDefault();
      return;
    }

    this.positionRangeMarker();
    this.props.onChange([parseInt(this.lowEl.value, 10), parseInt(this.hiEl.value, 10)]);
  };

  handleMouseUp = event => {
    if (event && event.target) {
      this.setState({
        lastUsed: event.target === this.lowEl ? PICKER_LOW : PICKER_HI,
      });
    }

    this.props.onChangeEnd([parseInt(this.lowEl.value, 10), parseInt(this.hiEl.value, 10)]);
  };

  positionRangeMarker() {
    if (this.lowEl && this.hiEl) {
      const { max, min } = this.props;

      const adjustedLow = this.lowEl.value - min;
      const adjustedHi = this.hiEl.value - min;
      const adjustedMax = max - min;

      const width = ((adjustedHi - adjustedLow) / adjustedMax) * 100;
      const left = (adjustedLow / adjustedMax) * 100;

      this.fillEl.style.left = `${left}%`;
      this.fillEl.style.width = `${width}%`;
    }
  }

  render() {
    const { min, max, value } = this.props;

    const { lastUsed } = this.state;

    const [valueMin, valueMax] = value || [min, max];

    return (
      <div className="range-picker">
        <div className="range-picker__fill" ref={el => (this.fillEl = el)} />
        <div className="range-picker__inputs">
          <input
            className={classNames({
              'range-picker__input--top': lastUsed === PICKER_LOW,
            })}
            type="range"
            min={min}
            max={max}
            value={valueMin}
            onInput={this.handleInput}
            onMouseUp={this.handleMouseUp}
            onTouchEnd={this.handleMouseUp}
            ref={el => (this.lowEl = el)}
          />
          <input
            className={classNames({
              'range-picker__input--top': lastUsed === PICKER_HI,
            })}
            type="range"
            min={min}
            max={max}
            value={valueMax}
            onInput={this.handleInput}
            onMouseUp={this.handleMouseUp}
            onTouchEnd={this.handleMouseUp}
            ref={el => (this.hiEl = el)}
          />
        </div>
      </div>
    );
  }
}

RangePicker.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func,
  onChangeEnd: PropTypes.func,
};
